<template>
  <div class="w-100 my-5">
    <div v-if="postList">
      <div class="row mx-auto box-white">
        <div class="col-sm my-1 vertical-center">
          <span class="font-bold font-15 alpha-07">{{ $t('post') }}:</span>
          <span class="mx-5 font-bold font-20">{{ items.length }}</span>
        </div>
        <div :class="`col-sm my-1 vertical-center ${isMobile ? '' : 'justify-content-end'}`">
          <input class="w-75" v-model="keyword" />
          <v-btn class="ml-2" icon small @click="keyword = ''" :disabled="!keyword">
            <i class="flaticon-circle"></i>
          </v-btn>
        </div>
      </div>
      <div class="row my-5" v-if="(items.length > 0)">
        <div :class="`col-sm${colSmSize}`" v-for="(item, index) in items" :key="(item, index)">
          <v-card class="my-2 p-0 box-white d-flex flex-column">
            <v-img style="cursor: zoom-in" height="200px" :src="item.photoUrl" @click="openImageViewer(index)" />
            <div class="mx-2 mt-1 vertical-center">
              <img class="circle-image-30" :src="item.userPhotoUrl" />
              <span class="ml-2 ellipsis font-12">{{ item.userName }}</span>
            </div>
            <span class="mx-3 mt-2 ellipsis font-12">{{ item.description }}</span>
            <div class="mx-3 my-2 d-flex justify-content-between vertical-center ">
              <i class="fa fa-calendar-alt font-12 color-black"></i>
              <span class="ml-2 font-12">{{ getDateStringFromTimestamp(item.createdAt) }}</span>
              <v-btn class="ml-auto" icon small @click="deletePostInfoTask(item.postId, item.userId)">
                <i class="fa fa-trash color-black"></i>
              </v-btn>
            </div>
          </v-card>
        </div>
      </div>
      <div class="py-40 center" v-else>
        <span class="font-20 alpha-07">No post found!</span>
      </div>
    </div>
    <div class="py-40 center" v-else>
      <p>Please wait ...</p>
      <b-spinner type="grow"></b-spinner>
    </div>
    <!-- VueEasyLightbox Component -->
    <VueEasyLightbox
      :visible="visibleImageViewer"
      :imgs="images"
      :index="imageIndex"
      @hide="visibleImageViewer = false"
      />
    <!-- VueEasyLightbox Component end -->
  </div>
</template>


<script>
import VueEasyLightbox from 'vue-easy-lightbox';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../main';
import { getDateStringFromTimestamp, showLoading } from '../../../functions';

import profile from '@/assets/image/profile.jpg';

export default {
  name: 'PostList',
  components: {
    VueEasyLightbox
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    colSmSize() {
      return this.$store.state.colSmSize;
    },
    userList() {
      return this.$store.state.userList;
    },
    postList() {
      return this.$store.state.postList;
    }
  },
  watch: {
    userList() {
      this.refreshData();
    },
    postList() {
      this.refreshData();
    },
    keyword() {
      this.refreshData();
    }
  },
  data() {
    return {
      assets: {
        profile
      },
      visibleImageViewer: false,
      imageIndex: 0,
      images: [],
      items: [],
      keyword: ''
    }
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    getDateStringFromTimestamp,
    refreshData() {
      if (this.postList && this.userList) {
        const items = [];
        const keyword = this.keyword.toLowerCase();
        this.postList.forEach(postInfo => {
          const userInfo = this.getUserInfo(postInfo.userId);
          if (userInfo && userInfo.userName.toLowerCase().includes(keyword)) {
            const item = JSON.parse(JSON.stringify(postInfo));
            item['userName'] = userInfo.userName;
            item['userPhotoUrl'] = userInfo.photoUrl ? userInfo.photoUrl : this.assets.profile;
            items.push(item);
          }
        });
        items.sort((a, b) => (a.createdAt.seconds < b.createdAt.seconds) ? 1 : -1);
        this.images = [];
        items.forEach(info => {
          this.images.push({
            title: info.description,
            src: info.photoUrl
          });
        });
        this.items = items;
      }
    },
    getUserInfo(userId) {
      return this.userList ? this.userList.find(element => element.userId === userId) : null;
    },
    openImageViewer(index) {
      this.imageIndex = index;
      this.visibleImageViewer = true;
    },
    deletePostInfoTask(postId, userId) {
      if (!confirm(this.$t('confirm_delete_', [this.$t('post')]))) {
        return;
      }
      const reason = prompt(this.$t('reason'));
      if (!reason) {
        return;
      }
      const params = {
        functionName: 'deletePost',
        postId: postId,
        userId: userId,
        reason: reason
      };
      const loader = showLoading(this, 1);
      const func = httpsCallable(functions, this.ADMIN_FUNCTION);
      func(JSON.stringify(params)).then(response => {
        loader.hide();
        if (response.data === this.RESULT_SUCCESS) {
          this.$toast.success(this.$t('success'));
        } else {
          this.$toast.error(response.data);
        }
      }).catch(error => {
        loader.hide();
        this.$toast.error(error.code + ', ' + error.message);
      });
    }
  }
};
</script>